export default {
  state: {
    Cards: [],
  },
  getters: {
    getTeams: (state) => state.Cards,
  },
  mutations: {
    setTeams(state, Cards) {
      state.Cards = Cards;
    },
  },
  actions: {
    async fetchTeams({ commit }) {
      try {
        const response = await fetch("/dental/api/team.json"); // Adjust the path as needed
        const data = await response.json();

        // Commit the data to the store
        commit("setTeams", data);
      } catch (error) {
        console.error("Error fetching Teams:", error);
      }
    },
  },
};
